import { loadTenants } from '../api/tenants';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { ResourceType } from 'vince-core/types/common';
import { Action } from 'vince-core/types/roles';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();

    store.registerResource('TENANT', 'tenants.resource.tenant', [Action.WRITE, Action.READ], async () => {
        const { items } = await loadTenants();
        return items.map(it => ({
            id: it.tenantId,
            key: it.tenantName,
            label: it.tenantAlias || it.tenantName,
            resourceType: 'TENANT',
            usable: true
        }));
    }, undefined, [ResourceType.TENANT]);
});
